export default function PrivacyPolicy() {
  return (
    <div className="max-h-full overflow-auto p-10">
      <h1 className="-ml-2 mb-2 text-2xl font-bold">Politique de Confidentialité</h1>
      <p>
        <strong>Dernière mise à jour :</strong> [Date]
      </p>

      <h2>1. Responsable du traitement</h2>
      <p>Le responsable du traitement des données personnelles collectées via la plateforme est :</p>
      <ul>
        <li>
          <strong>Noms :</strong> Henri Leclair et Arnaud Ambroselli
        </li>
        <li>
          <strong>Contact :</strong> <a href="mailto:contact@medspot.fr">contact@medspot.fr</a>
        </li>
      </ul>

      <h2>2. Données collectées</h2>
      <p>Nous collectons uniquement les données nécessaires au bon fonctionnement de la plateforme :</p>
      <ul>
        <li>
          <strong>Identifiant :</strong> Adresse e-mail fournie lors de l'inscription.
        </li>
        <li>
          <strong>Données personnelles :</strong> nom, prénom, photo de profil, établissement, spécialité, status, lieu
          d'exercice (facultatif), RPPS (facultatif)
        </li>
        <li>
          <strong>Cookies :</strong> Un cookie d'authentification pour gérer votre session.
        </li>
      </ul>

      <h2>3. Finalités du traitement</h2>
      <p>Les données collectées sont utilisées exclusivement pour :</p>
      <ul>
        <li>Créer et gérer votre compte utilisateur.</li>
        <li>Vérifier votre identité et votre statut de professionnel de santé.</li>
        <li>Assurer un accès sécurisé et performant à la plateforme.</li>
      </ul>

      <h2>4. Absence de partage avec des tiers</h2>
      <p>
        Vos données personnelles ne sont partagées avec aucune tierce partie. Elles sont exclusivement utilisées par
        MedSpot.fr pour les finalités décrites ci-dessus.
      </p>

      <h2>5. Durée de conservation</h2>
      <p>
        Vos données sont conservées tant que votre compte reste actif. Une fois votre compte supprimé, les données
        associées sont également supprimées, sauf en cas d'obligation légale.
      </p>

      <h2>6. Sécurité des données</h2>
      <p>Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données :</p>
      <ul>
        <li>Chiffrement des données sensibles.</li>
        <li>Stockage sécurisé sur des serveurs conformes aux normes applicables.</li>
        <li>Accès limité aux seuls personnels autorisés.</li>
      </ul>

      <h2>7. Vos droits</h2>
      <p>Conformément à la réglementation, vous disposez des droits suivants :</p>
      <ul>
        <li>
          <strong>Droit d'accès :</strong> Obtenir une copie de vos données personnelles.
        </li>
        <li>
          <strong>Droit de rectification :</strong> Modifier vos données incorrectes ou incomplètes.
        </li>
        <li>
          <strong>Droit à l'effacement :</strong> Demander la suppression de vos données.
        </li>
        <li>
          <strong>Droit d'opposition :</strong> Refuser le traitement de vos données dans certains cas.
        </li>
      </ul>
      <p>
        Pour exercer vos droits, contactez-nous à l'adresse suivante :{" "}
        <a href="mailto:contact@medspot.fr">contact@medspot.fr</a>.
      </p>
      <p>
        Pour supprimer votre compte, veuillez vous connecter, aller dans "modifier mon profil" et faire défiler vers le
        bas pour sélectionner "supprimer mon compte".
      </p>

      <h2>8. Utilisation des cookies</h2>
      <p>
        Nous utilisons uniquement un cookie d'authentification pour gérer votre session sur la plateforme. Ce cookie est
        indispensable et ne collecte aucune donnée supplémentaire.
      </p>

      <h2>9. Modifications de la politique de confidentialité</h2>
      <p>
        Cette politique de confidentialité peut être mise à jour pour refléter des changements dans nos pratiques ou
        obligations légales. Toute modification sera communiquée via la plateforme.
      </p>

      <h2>10. Contact</h2>
      <p>
        Pour toute question ou réclamation relative à cette politique, contactez-nous à :{" "}
        <a href="mailto:contact@medspot.fr">contact@medspot.fr</a>.
      </p>

      <h2>11. Normes de sécurité pour les enfants</h2>
      <p>
        MedSpot.fr s'engage à respecter les normes de sécurité pour les enfants. Nous avons mis en place des politiques
        strictes pour prévenir les abus et l'exploitation sexuelle des enfants (CSAE). Nos normes incluent :
      </p>
      <ul>
        <li>Formation régulière de notre personnel sur la détection et la prévention des abus.</li>
        <li>Surveillance proactive des interactions sur la plateforme pour identifier les comportements suspects.</li>
        <li>
          Outils de signalement faciles à utiliser pour permettre aux utilisateurs de signaler des préoccupations.
        </li>
        <li>
          Collaboration avec des organisations spécialisées dans la protection des enfants pour améliorer nos pratiques.
        </li>
      </ul>
      <p>
        Pour toute question ou préoccupation concernant la sécurité des enfants, veuillez contacter notre point de
        contact à l'adresse suivante : <a href="mailto:contact@medspot.fr">contact@medspot.fr</a>.
      </p>
      <p>
        MedSpot.fr permet aux utilisateurs de signaler des préoccupations concernant la sécurité des enfants via
        l'application. Pour en savoir plus sur les exigences de signalement, visitez notre Centre d'aide.
      </p>
      <p>
        Notre application respecte toutes les lois pertinentes en matière de sécurité des enfants et signale aux
        autorités régionales et nationales. Pour en savoir plus sur le signalement aux autorités compétentes, visitez
        notre Centre d'aide.
      </p>
    </div>
  );
}
